import { Button, CircularProgress } from '@material-ui/core';
import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import DirectionsIcon from '@material-ui/icons/Directions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import Breadcrumbs from '../../elements/Breadcrumbs';
import {
    CustomIconButton, CustomInputBase, CustomPaper, Label, MainContainer, QuestionCard, OrganisationsList, LoaderContainer, NextBtn
} from './Direction.style';
import SearchIcon from '../../assets/allIcons/SearchIcon';

const Direction = ({
    isLoading,
    isDirection,
    onChangeIsDirection,
    companyList,
    filterStr,
    setFilterStr,
    handleSelectCompany,
    handleClickNextBtn,
    sendingCompanyId,
}) => {

    return (
        <>
            <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: 'Направление' }]} />
            <MainContainer>
                <QuestionCard>
                    Есть ли у Вас направление к специалисту?
                    <div>
                        <Tooltip title="Прием по полису ОМС" enterDelay={300} leaveDelay={200}>
                            <Button
                                onClick={() => onChangeIsDirection('yes')}
                                variant={isDirection === 'yes' ? 'contained' : 'text'}
                                color='secondary'
                                size='large'
                            >
                                ДА
                            </Button>
                        </Tooltip>

                        <Tooltip title="Наличный расчет" enterDelay={300} leaveDelay={200}>
                            <Button
                                onClick={() => onChangeIsDirection('no')}
                                variant={isDirection === 'no' ? 'contained' : 'text'}
                                color='secondary'
                                size='large'
                            >
                                НЕТ
                            </Button>
                        </Tooltip>
                    </div>
                </QuestionCard>
                <CustomPaper component="form">
                    <CustomInputBase
                        placeholder="Поиск"
                        inputProps={{ 'aria-label': 'Поиск' }}
                        value={filterStr}
                        onChange={(e) => setFilterStr(e.target.value)}
                        disabled={isDirection === 'no'}
                    />
                    <CustomIconButton aria-label="search" >
                        <SearchIcon />
                    </CustomIconButton>
                </CustomPaper>
                {isDirection === 'yes' && companyList.length
                    ? <OrganisationsList>
                        <List component="nav" aria-label="company list">
                            {companyList.map((item) =>
                                <ListItem
                                    selected={item.oid === sendingCompanyId}
                                    button
                                    key={item.oid}
                                    onClick={() => handleSelectCompany(item.oid)}
                                >
                                    <Tooltip title={item.fullName} enterDelay={500} leaveDelay={200}>
                                        <ListItemText primary={item.shortName} />
                                    </Tooltip>

                                </ListItem>
                            )}
                        </List>
                    </OrganisationsList>
                    : <Label>Введите наименование медицинской организации, например: Клиника №2</Label>
                }
                {isLoading && isDirection === 'yes' && <LoaderContainer>
                    <CircularProgress size={40} />
                </LoaderContainer>
                }
            </MainContainer>
            <NextBtn onClick={handleClickNextBtn}></NextBtn>
        </>
    )
}

export default Direction;
